import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { DialogConfirm, DialogConfirmData } from 'app/dialogs/confirm/dialog-confirm';
import { DialogMortgageEligibilityCreateComponent } from 'app/dialogs/loans/mortgage-eligibility/create/dialog-mortgage-eligibility-create';
import { sortCompare } from 'app/helpers/sortCompare';
import { formatAddress } from 'app/helpers/stringHelpers';
import { ExposedListMortgageEligibilityInfoRes } from 'app/interfaces/responses/Exposed/exposedListMortgageEligibilityInfoRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { MortgageEligibilityInfoService } from 'app/services/api/mortgageEligibilityInfo/mortgageEligibilitInfo.service';

@Component({
    selector: 'loans-mortgage-eligibility-form-list',
    templateUrl: './loans-mortgage-eligibility-form-list.component.html',
    styleUrls: ['./loans-mortgage-eligibility-form-list.component.scss'],
})
export class LoansMortgageEligibilityFormListComponent implements OnInit {
    @ViewChild('tablePaginator ') displayedDataPaginator: MatPaginator;
    tableColumns: string[] = ['id', 'externalServiceId', 'originatingSystem', 'property', 'actions'];
    pageSize: number = 25;
    displayedData: MatTableDataSource<ExposedListMortgageEligibilityInfoRes> = new MatTableDataSource();
    formatAddress = formatAddress;

    constructor(
        private mortgageEligibilityInfoService: MortgageEligibilityInfoService,
        public lsrauthService: LsrauthService,
        private router: Router,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        this.fetchMortgageEligibilityForms();
    }

    ngAfterViewInit(): void {
        this.displayedData.paginator = this.displayedDataPaginator;
    }

    fetchMortgageEligibilityForms() {
        this.mortgageEligibilityInfoService.getMortgageEligibilityInfos().subscribe((res: ExposedListMortgageEligibilityInfoRes[]) => {
            this.displayedData.data = res;
        });
    }

    openNewMortgageEligibilityForm = () => {
        const dialogRef = this.dialog.open(DialogMortgageEligibilityCreateComponent, {
            autoFocus: false,
            restoreFocus: false,
            width: '450px',
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((id) => {
            this.router.navigate([this.router.url, id]);
        });
    };

    onDeleteForm = (item) => {
        const dialogRef = this.dialog.open(DialogConfirm, {
            autoFocus: false,
            restoreFocus: false,
            width: '450px',
            disableClose: true,
            data: {
                title: 'Staðfesta aðgerð',
                message: 'Ertu viss um að þú viljir eyða skjalinu ?',
            } as DialogConfirmData,
        });

        dialogRef.afterClosed().subscribe((confirm: boolean) => {
            if (!confirm) {
                return;
            }

            this.mortgageEligibilityInfoService.deleteMortgageEligibilityInfo(item.id).subscribe({
                next: () => {
                    this.fetchMortgageEligibilityForms();
                },
            });
        });
    };

    getPropertyDescription = (item: ExposedListMortgageEligibilityInfoRes) => {
        if (item.properties.length == 0) {
            return '';
        }

        let first = item.properties[0];
        let value = `${first.propertyNumber} - ${formatAddress(first.address, first.city, first.postalCode)}`;
        if (item.properties.length > 1) {
            value += ` (+${item.properties.length - 1})`;
        }
        return value;
    };

    //#region Table Sort and Filter

    searchFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        this.displayedData.filter = filterValue;
    }

    sortData(sort: Sort) {
        const data = this.displayedData.data.slice();
        if (!sort.active || sort.direction === '') {
            this.displayedData.data = data;
            return;
        }

        this.displayedData.data = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'id':
                    return sortCompare(a.id, b.id, isAsc);
                case 'externalServiceId':
                    return sortCompare(a.externalServiceId, b.externalServiceId, isAsc);
                default:
                    return 0;
            }
        });
    }

    //#endregion
}
